import { InvoiceData, InvoicePostRequest } from '../models/invoice';

export const StubInvoiceData: InvoiceData = {
  _id: '',
  project: '',
  invoiceNumber: '',
  invoiceDate: new Date(),
  invoiceAmount: 0,
  receivedAmount: 0,
  paymentExpectedDate: new Date(),
  paymentReceivedDate: new Date(),
  status: '',
  sentBy: '',
  bankAccount: '',
  createdAt: new Date(),
  updatedAt: new Date(),
  __v: 0,
};

export const StubInvoicePostRequest: InvoicePostRequest = {
  invoiceAmount: 0,
  invoiceDate: new Date(),
  receivedAmount: 0,
  paymentExpectedDate: new Date(),
  paymentReceivedDate: new Date(),
  status: '',
  sentBy: '',
  bankAccount: '',
  company: '',
  invoiceNumber: '',
};
